import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axios-base-query';

import type {
  StartNodeTaskResponse,
  NodeTaskStatusResponse,
  RemoveNodeTaskResponse,
} from '~s/controllers/task/controller';

interface StartNodeTaskRequest extends Record<string, any> {
  jobName: string;
}

export const nodeTaskApi = createApi({
  reducerPath: 'nodeTaskApi',
  baseQuery: axiosBaseQuery({ baseUrl: '/api/task' }),
  endpoints: (builder) => ({
    start: builder.mutation<StartNodeTaskResponse, StartNodeTaskRequest>({
      query: ({ jobName, ...data }) => ({
        url: `/v1/start/${jobName}`,
        method: 'post',
        data,
      }),
    }),
    status: builder.query<NodeTaskStatusResponse, string>({
      query: (jobId) => ({
        url: `/v1/status/${jobId}`,
        method: 'get',
      }),
    }),
    cancel: builder.mutation<RemoveNodeTaskResponse, string>({
      query: (jobId) => ({
        url: `/v1/id/${jobId}`,
        method: 'delete',
      }),
    }),
  }),
});
